/**
 * 向上取整
 * @param {原数字} num
 * @param {保留的小数位数} fix
 * @returns
 */
function upFixed(num, fix) {
  let result = '0'
  if (Number(num) && fix > 0) {
    // 简单的做个判断
    fix = +fix || 2
    num = num + ''
    if (/e/.test(num)) {
      // 如果是包含e字符的数字直接返回
      result = num
    } else if (!/\./.test(num)) {
      // 如果没有小数点
      result = num + `.${Array(fix + 1).join('0')}`
    } else {
      // 如果有小数点
      num = num + `${Array(fix + 1).join('0')}`
      const reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
      const floorStr = reg.exec(num)[0]
      if (+floorStr >= +num) {
        result = floorStr
      } else {
        const floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
        const point = /\./.test(floorNumber + '') ? '' : '.'
        const floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
        result = reg.exec(floorStr2)[0]
      }
    }
  }
  return result
}

const oVueFilter = {
  // 截取小数点后n位
  toFixedFn(val, num) {
    if (num) {
      const realVal = Number(val).toFixed(num)
      return realVal
    } else {
      return val
    }
  },
  // 精确小数点三位,不四舍五入
  exactPointThree(val) {
    let newVal
    val = Number(val)
    if (val < 0) {
      val = val.toString().substring(1)
      newVal = Number(val.toString().match(/^\d+(?:\.\d{0,3})?/)) * -1
    } else {
      newVal = Number(val.toString().match(/^\d+(?:\.\d{0,3})?/))
    }
    // 整数自动补0
    if (newVal.toString().indexOf('.') === -1) {
      newVal += '.000'
    }
    const len = newVal.toString().indexOf('.') + 1
    // 2位数自动补0
    if (
      newVal
        .toString()
        .substring(len)
        .split('').length === 2
    ) {
      newVal += '0'
    }
    // 1位数自动补0
    if (
      newVal
        .toString()
        .substring(len)
        .split('').length === 1
    ) {
      newVal += '00'
    }
    return newVal
    //   return Number(num.toString().match(/^\d+(?:\.\d{0,3})?/))
  },
  // 精确小数点两位,不四舍五入
  exactPointTwo(val) {
    let newVal
    val = Number(val)
    if (val < 0) {
      val = val.toString().substring(1)
      newVal = Number(val.toString().match(/^\d+(?:\.\d{0,2})?/)) * -1
    } else {
      newVal = Number(val.toString().match(/^\d+(?:\.\d{0,2})?/))
    }
    // 整数自动补0
    if (newVal.toString().indexOf('.') === -1) {
      newVal += '.00'
    }
    const len = newVal.toString().indexOf('.') + 1
    // 1位数自动补0
    if (
      newVal
        .toString()
        .substring(len)
        .split('').length === 1
    ) {
      newVal += '0'
    }
    return newVal
  },
  exactPointNon(val) {
    return val
  },
  // 成交类型 1-摘牌，2-挂牌，3-调期挂牌，4-强制挂牌，5-协议交收,6-调期交收，7-到期交收9-特殊商品交收 0-协议挂牌
  tradeTypeFormatter(id) {
    let statusName = null
    switch (id) {
      case 1:
        statusName = '挂单'
        break
      case 2:
        statusName = '摘单'
        break
      case 3:
        statusName = '调期挂牌'
        break
      case 4:
        statusName = '强制挂牌'
        break
      case 5:
        statusName = '协议交收'
        break
      case 6:
        statusName = '调期交收'
        break
      case 7:
        statusName = '到期交收'
        break
      case 9:
        statusName = '特殊商品交收'
        break
      case 0:
        statusName = '货权转让'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  dateFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
  },
  dateFormateMin(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${hour}:${min}`
  },
  dateFormateDay(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    if (timer) {
      var newTimer = timer
      const date = new Date(newTimer)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map(item => (item < 10 ? '0' + item : item))
      return `${year}-${month}-${day}`
    } else {
      return ''
    }
  },
  dateFormateDayCh(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${year}年${month}月${day}日`
  },
  dateFormateDayTime(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${year}年${month}月${day}日 ${hour}:${min}:${sec}`
  },
  // 1-订立，2-转让，3-现货买进转让，4-强制转让，5-协议交收
  tradeTypeFormat(t) {
    switch (t) {
      case 1:
        return '订立'

      case 2:
        return '转让'

      case 3:
        return '现货买进转让'

      case 4:
        return '代为转让'

      case 5:
        return '协议交收'

      default:
        return '未知'
    }
  },
  //
  deliverTypeFormate(t) {
    switch (t) {
      case 1:
        return '协议交收'

      case 2:
        return '到期交收'

      case 3:
        return '强制减仓'

      default:
        return '未知'
    }
  },
  // 交收类型 M是到期交收，T是交收
  deliveryType(id) {
    let statusName = null
    switch (id) {
      case 'T':
        statusName = '提前交收'
        break
      case 'M':
        statusName = '到期交收'
        break
      case 'S':
        statusName = '仓库交收'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  deliveryStatuss(val) {
    // w 待发货 s 已发货 u 已撤销
    if (val === 'W') {
      return '待出库'
    } else if (val === 'S' || val === 'T') {
      return '已出库'
    } else if (val === 'U') {
      return '已撤销'
    } else {
      return ''
    }
  },
  // 交收状态 W：待审核T：审核通过F：审核拒绝 C：已成交
  deliveryStatus(id) {
    let statusName = null
    switch (id) {
      case 'W':
        statusName = '待审核'
        break
      case 'T':
        statusName = '审核通过'
        break
      case 'F':
        statusName = '审核拒绝'
        break
      case 'U':
        statusName = '已撤销'
        break
      case 'C':
        statusName = '交收完成'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  // 企业认证状态
  BankSignStatus(id) {
    let statusName = null
    switch (id) {
      case 0:
        statusName = '请前往签约页面进行签约!'
        break
      case 1:
        statusName = ''
        break
      case 2:
        statusName = '解约成功'
        break
      case 3:
        statusName = '您的签约正在申请中,请耐心等待结果!'
        break
      case 4:
        statusName = '您的解约正在申请中,请耐心等待结果!'
        break
      case 5:
        statusName = '绑卡出错'
        break
      case 6:
        statusName =
                    '打款验证出错,请前往入金记录页面获取第一次入金流水号,并在此页面点击打款验证输入认证金额及流水号'
        break
      case 7:
        statusName = '解绑在途'
        break
      case 8:
        statusName = '解绑出错'
        break
      case 11:
        statusName = '绑卡在途'
        break
      case 12:
        statusName = '打款验证在途'
        break
      case 13:
        statusName =
                    '机构绑卡成功,请去网银端入金,并前往银行签约界面进行打款验证'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  toThousands(num) {
    if (typeof num === 'number' && !isNaN(num)) {
      num = num.toString()
      var sign = ''
      if (num[0] == '-') {
        num = num.slice(1)
        sign = '-'
      }

      var result = ''
      num = Number(num.toString() || 0).toFixed(2)
      var numAry = num.toString().split('.')
      var preNum = numAry[0]
      var lastNum = numAry[1]
      while (preNum.length > 3) {
        result = ',' + preNum.slice(-3) + result
        preNum = preNum.slice(0, preNum.length - 3)
      }
      if (preNum) {
        result = preNum + result
      }
      result = result + '.' + lastNum
      return sign + result
    } else {
      return num
    }
  },
  priceFormat(e) {
    return Number(e).toFixed(2)
  },
  priceFormat1(e) {
    if (Number(e) >= 0) {
      if (typeof e === 'number' && !isNaN(e)) {
        var result = ''
        e = Number(e.toString() || 0).toFixed(2)
        var numAry = e.toString().split('.')
        var preNum = numAry[0]
        var lastNum = numAry[1]
        while (preNum.length > 3) {
          result = ',' + preNum.slice(-3) + result
          preNum = preNum.slice(0, preNum.length - 3)
        }
        if (preNum) {
          result = preNum + result
        }
        result = result + '.' + lastNum
        return result
      } else {
        return e
      }
      // return Number(e).toFixed(2)
    } else {
      return '--'
    }
  },
  amountWFormat(intN) { // 向上取整
    if (typeof intN === 'number') {
      if (intN > 100000000) {
        return upFixed(intN / 100000000, 2) + '亿'
      } else if (intN > 10000) {
        return upFixed(intN / 10000, 2) + '万'
      } else {
        // 2022.08.26修改不要小数点Math.ceil(intN) 万内不处理
        // return Number(Math.ceil(intN * 100) / 100).toFixed(2) // 向上处理
        return Number(intN).toFixed(2)
      }
    } else {
      return intN
    }
  },
  amountFixFormat(intN) { // 四舍五入
    if (typeof intN === 'number') {
      if (intN > 100000000) {
        return (intN / 100000000).toFixed(2) + '亿'
      } else if (intN > 10000) {
        return (intN / 10000).toFixed(2) + '万'
      } else {
        return intN // intN.toFixed(2) 2022.08.26修改
      }
    } else {
      return intN
    }
  },
  addSign(str) { // 删除"+"
    str = str + ''
    return str.split('+').join('')
  },
  // 商品价格千分位
  newtoThousandss(num, dot) {
    if (num && !isNaN(Number(num))) {
      var result = ''
      result = Number(num.toString() || 0).toFixed(dot)
      // var numAry = num.toString().split('.')
      // var preNum = numAry[0]
      // var lastNum = numAry[1]
      // while (preNum.length > 3) {
      //   result = ',' + preNum.slice(-3) + result
      //   preNum = preNum.slice(0, preNum.length - 3)
      // }
      // if (preNum) {
      //   result = preNum + result
      // }
      // // eslint-disable-next-line eqeqeq
      // if (dot == 0) {
      //   return result
      // }
      // result = result + '.' + lastNum
      return result
    } else {
      return '0.00'
    }
  },
  isPoneMatch(str) {
    if (str) {
      var enStr = str.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
      return enStr
    }
    return str
  },
  // 订单状态 0待发货  9退款中   1待收货   2已完成 3 退款成功
  statusFormat(id) {
    let statusName = null
    switch (id) {
      case 0:
        statusName = '待发货'
        break
      case 1:
        statusName = '待收货'
        break
      case 2:
        statusName = '已完成'
        break
      case 3:
        statusName = '退款成功'
        break
      case 8:
        statusName = '缺货退款'
        break
      case 9:
        statusName = '退款中'
        break
        //  18：未退回  19：部分退回  20 全部退回  21：申请退回  22 申请全部退回
      case 18:
        statusName = '未退回'
        break
      case 19:
        statusName = '部分退回'
        break
      case 20:
        statusName = '全部退回'
        break
      case 21:
        statusName = '申请退回'
        break
      case 22:
        statusName = '申请全部退回'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  // 售后订单状态 1:已取消 2:待审核 3:已驳回 4:已通过
  auditStatusFormat(id) {
    let statusName = null
    switch (id) {
      case 1:
        statusName = '已取消'
        break
      case 2:
        statusName = '待审核'
        break
      case 3:
        statusName = '已驳回'
        break
      case 4:
        statusName = '已通过'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  }
}

export default oVueFilter
